import { CanApiAuthenticator } from "authenticators/canApiAuthenticator";
import { ConfigApp } from "configApp";
import IFeatureFlag from "interfaces/IFeatureFlag";

import BaseClient from "./baseClient";

export default class FlagClient extends BaseClient {
  private readonly endpoint: string = "api/Flag";

  public constructor() {
    super(ConfigApp.endpoints.canApi, new CanApiAuthenticator());
  }

  public async GetFlagsByNameAsync(flagNames: string[]): Promise<IFeatureFlag[]> {
    return this.postWithResponse<IFeatureFlag[]>(`${this.endpoint}`, flagNames);
  }
}
